/**
 * AUTO-GENERATED by scripts/sync-examples-catalog.mjs — DO NOT EDIT BY HAND.
 * Source of truth: examples/examples-health.matrix.json (repo root) + the
 * examples/ tree (full inventory counts).
 * Regenerate: pnpm --filter @holoscript/mcp-server sync:examples-catalog
 *
 * This is the audited PUBLIC example catalog (status + link policy per example)
 * plus a full-tree inventory summary, projected so the get_examples MCP tool
 * serves real repo state instead of a stale hardcoded shadow library.
 */
export interface ExampleCatalogEntry {
  slug: string;
  path: string;
  format: string;
  category: string;
  status: string;
  linkPolicy: string;
  reason: string;
  priority: boolean;
}

export interface ExampleInventory {
  /** Total .hs/.hsplus/.holo example files in examples/ (excludes .refreshed.* siblings). */
  total: number;
  byFormat: Record<string, number>;
  byCategory: Record<string, number>;
}

export const EXAMPLE_CATALOG: ExampleCatalogEntry[] = [
  {
    "slug": "hello-world",
    "path": "examples/hello-world.hs",
    "format": "hs",
    "category": "root",
    "status": "supported",
    "linkPolicy": "public-supported",
    "reason": "Baseline .hs quickstart example.",
    "priority": true
  },
  {
    "slug": "solar_system",
    "path": "examples/solar_system.holo",
    "format": "holo",
    "category": "root",
    "status": "supported",
    "linkPolicy": "public-supported",
    "reason": "Baseline .holo scene example.",
    "priority": true
  },
  {
    "slug": "multiplayer-game",
    "path": "examples/multiplayer-game.hsplus",
    "format": "hsplus",
    "category": "root",
    "status": "supported",
    "linkPolicy": "public-supported",
    "reason": "Baseline .hsplus behavior example.",
    "priority": true
  },
  {
    "slug": "three-format-showcase/smart-gallery",
    "path": "examples/three-format-showcase/smart-gallery.hs",
    "format": "hs",
    "category": "three-format-showcase",
    "status": "supported",
    "linkPolicy": "public-supported",
    "reason": "Procedural lane of the three-format showcase parses successfully.",
    "priority": true
  },
  {
    "slug": "three-format-showcase/smart-gallery",
    "path": "examples/three-format-showcase/smart-gallery.hsplus",
    "format": "hsplus",
    "category": "three-format-showcase",
    "status": "supported",
    "linkPolicy": "public-supported",
    "reason": "Behavior lane of the three-format showcase parses successfully.",
    "priority": true
  },
  {
    "slug": "novel-use-cases/05-robot-training-metaverse",
    "path": "examples/novel-use-cases/05-robot-training-metaverse.holo",
    "format": "holo",
    "category": "novel-use-cases",
    "status": "aspirational-grammar",
    "linkPolicy": "public-aspirational-label-required",
    "reason": "Uses autonomous ecosystem behavior blocks inside a .holo composition; HoloCompositionParser does not accept that grammar yet.",
    "priority": true
  },
  {
    "slug": "novel-use-cases/05-robot-training-metaverse",
    "path": "examples/novel-use-cases/05-robot-training-metaverse.hs",
    "format": "hs",
    "category": "novel-use-cases",
    "status": "supported",
    "linkPolicy": "public-supported",
    "reason": "Verified 2026-07-03: on_error(...) pipeline handler syntax now parses (compiler-wasm grammar work in flight); promoted from aspirational-grammar.",
    "priority": true
  },
  {
    "slug": "novel-use-cases/05-robot-training-metaverse",
    "path": "examples/novel-use-cases/05-robot-training-metaverse.hsplus",
    "format": "hsplus",
    "category": "novel-use-cases",
    "status": "supported",
    "linkPolicy": "public-supported",
    "reason": "Verified 2026-07-03: arrow transition shorthand in state-machine maps now parses (compiler-wasm grammar work in flight); promoted from aspirational-grammar.",
    "priority": true
  },
  {
    "slug": "novel-use-cases/13-disaster-robotics-swarm",
    "path": "examples/novel-use-cases/13-disaster-robotics-swarm.holo",
    "format": "holo",
    "category": "novel-use-cases",
    "status": "supported",
    "linkPolicy": "public-supported",
    "reason": "Verified 2026-07-03: full disaster-training scene grammar now parses (compiler-wasm grammar work in flight); promoted from aspirational-grammar.",
    "priority": true
  },
  {
    "slug": "novel-use-cases/13-disaster-robotics-swarm",
    "path": "examples/novel-use-cases/13-disaster-robotics-swarm.hs",
    "format": "hs",
    "category": "novel-use-cases",
    "status": "supported",
    "linkPolicy": "public-supported",
    "reason": "Verified 2026-07-03: dotted property expressions in pipeline properties now parse (compiler-wasm grammar work in flight); promoted from aspirational-grammar.",
    "priority": true
  },
  {
    "slug": "novel-use-cases/13-disaster-robotics-swarm",
    "path": "examples/novel-use-cases/13-disaster-robotics-swarm.hsplus",
    "format": "hsplus",
    "category": "novel-use-cases",
    "status": "supported",
    "linkPolicy": "public-supported",
    "reason": "Verified 2026-07-03: arrow transition shorthand in behavior state maps now parses (compiler-wasm grammar work in flight); promoted from aspirational-grammar.",
    "priority": true
  },
  {
    "slug": "sample-projects/physics-playground",
    "path": "examples/sample-projects/physics-playground.holo",
    "format": "holo",
    "category": "sample-projects",
    "status": "supported",
    "linkPolicy": "public-supported",
    "reason": "Verified 2026-07-03: nested post_processing blocks (bloom { ... }) now parse (compiler-wasm grammar work in flight); promoted from aspirational-grammar.",
    "priority": true
  },
  {
    "slug": "showcase/physics-playground",
    "path": "examples/showcase/physics-playground.holo",
    "format": "holo",
    "category": "showcase",
    "status": "supported",
    "linkPolicy": "public-supported",
    "reason": "Verified 2026-07-03: showcase-scale physics grammar now parses (compiler-wasm grammar work in flight); promoted from aspirational-grammar.",
    "priority": true
  },
  {
    "slug": "showcase/realistic-forest-refreshed",
    "path": "examples/showcase/realistic-forest.refreshed.holo",
    "format": "holo",
    "category": "showcase",
    "status": "supported",
    "linkPolicy": "public-supported",
    "reason": "Parser success (verified 2026-07-03); flagship example for docs/handbooks/holoscript-realistic-authoring-patterns.md — @advanced_pbr materials, imported glb models, @time_of_day/@volumetric_clouds/@wind environment drivers.",
    "priority": true
  },
  {
    "slug": "showcase/realistic-forest",
    "path": "examples/showcase/realistic-forest.holo",
    "format": "holo",
    "category": "showcase",
    "status": "expected-fail",
    "linkPolicy": "internal-only",
    "reason": "Pre-refresh version; parser rejects legacy composition syntax at line 352 (Expected LBRACE, got AT). Superseded by realistic-forest.refreshed.holo — kept as a before/after reference in the authoring-patterns handbook, not a working example.",
    "priority": false
  },
  {
    "slug": "physics/advanced-physics-showcase",
    "path": "examples/physics/advanced-physics-showcase.holo",
    "format": "holo",
    "category": "physics",
    "status": "supported",
    "linkPolicy": "public-supported",
    "reason": "Verified 2026-07-03: nested post_processing blocks and advanced physics traits now parse (compiler-wasm grammar work in flight); promoted from aspirational-grammar.",
    "priority": true
  },
  {
    "slug": "product-viewer",
    "path": "examples/product-viewer.holo",
    "format": "holo",
    "category": "root",
    "status": "expected-fail",
    "linkPolicy": "internal-only",
    "reason": "Current .holo parser rejects the product viewer's domain-dataviz string property form; keep out of public working-example links until promoted.",
    "priority": true
  },
  {
    "slug": "hololand/vv-results-visualization-space",
    "path": "examples/hololand/vv-results-visualization-space.holo",
    "format": "holo",
    "category": "hololand",
    "status": "supported",
    "linkPolicy": "public-supported",
    "reason": "Verified 2026-07-03: HoloLand V&V visualization grammar with nested post-processing and dashboard constructs now parses (compiler-wasm grammar work in flight); promoted from aspirational-grammar.",
    "priority": true
  },
  {
    "slug": "site",
    "path": "examples/site.holo",
    "format": "holo",
    "category": "root",
    "status": "deprecated",
    "linkPolicy": "archive-only",
    "reason": "Legacy v5 landing-page composition retained as archive material; do not feature as a current parser-supported example.",
    "priority": true
  }
];

/** Full-tree inventory of examples/, resolved at build time (no runtime fs). */
export const EXAMPLE_INVENTORY: ExampleInventory = {
  "total": 487,
  "byFormat": {
    "holo": 361,
    "hs": 71,
    "hsplus": 55
  },
  "byCategory": {
    "accessibility": 1,
    "root": 42,
    "affordances": 3,
    "agents": 7,
    "ai-generation": 2,
    "ai-npcs": 1,
    "ar": 1,
    "ar-foundation": 7,
    "atoms": 2,
    "audio": 2,
    "autonomous-ecosystems": 12,
    "avatars": 5,
    "biomedical": 1,
    "compute": 1,
    "cross-domain": 3,
    "cross-reality": 3,
    "cryptography": 6,
    "demolition-demo": 1,
    "domain-starters": 13,
    "economy": 2,
    "emotion": 3,
    "enterprise": 9,
    "export-pipelines": 5,
    "general": 6,
    "getting-started": 2,
    "gold-game": 4,
    "government-civic": 1,
    "hololand": 27,
    "hsplus": 8,
    "integration": 5,
    "interaction": 1,
    "interoperability": 1,
    "iot": 1,
    "language-reference": 13,
    "lighting": 4,
    "lotus-flower": 2,
    "multi-target-demo": 1,
    "multisensory": 3,
    "narrative": 3,
    "native": 24,
    "native-assets": 7,
    "networking": 1,
    "neuromorphic": 3,
    "norm-lifecycle": 1,
    "novel-use-cases": 39,
    "npc-roles": 5,
    "openusd": 1,
    "perception-tests": 7,
    "persistence": 3,
    "phonesleevevr": 1,
    "physics": 1,
    "pipelines": 5,
    "platforms": 11,
    "plugins": 1,
    "presets": 8,
    "procedural": 4,
    "quickstart": 6,
    "real-world": 3,
    "reconstruction": 1,
    "rendering": 5,
    "robotics": 3,
    "sample-projects": 3,
    "services": 4,
    "showcase": 9,
    "social-commerce": 3,
    "specialized": 5,
    "stress-tests": 31,
    "TEMPLATE": 1,
    "templates": 5,
    "three-format-showcase": 3,
    "three-world": 2,
    "traits": 12,
    "v5.0-hardened": 22,
    "v6": 6,
    "volumetric": 6,
    "volumetric-advanced": 5,
    "weather": 5,
    "webgpu-compute": 6,
    "wisdom-demo": 1,
    "xr": 4
  }
};

/** Link policies safe to surface as working/featured examples. */
export const PUBLIC_LINK_POLICIES = new Set<string>([
  'public-supported',
  'public-aspirational-label-required',
]);
